export default __webpack_public_path__ + "static/media/grands_ouvrages.a6f0903b.webp";